import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import { apiClient } from '../../apiClient'
import {KaggUserPropertyPayload} from './type'

class KaggApi {
  private api: AxiosInstance

  constructor(config: AxiosRequestConfig) {
    this.api = apiClient.create(config)
  }

  getUserData = async (payload: KaggUserPropertyPayload) => {
    return this.api.post('/gw2/kagg/internal/v1/cms/user', payload)
  }
}

export default KaggApi
